import Vue from 'vue'

try {
  new Function("(a = 0) => a") // Check if we can do ES6
  import('v-calendar')
  .then((vc) => {
    var VCalendar = vc.default
    Vue.use(VCalendar, {
      locales: {
        'fi': {
          firstDayOfWeek: 2,
          masks: {
            weekdays: 'WW',
            L: 'D.M.YYYY'
          }
        }
      }
    })
  })
} catch (err) {
  console.log(err)
}

/*
import VCalendar from 'v-calendar'

Vue.use(VCalendar, {
  locales: {
    'fi': {
      firstDayOfWeek: 2,
      masks: {
        weekdays: 'WW',
        L: 'DD.MM.YYYY'
      }
    }
  }
})
*/